import { useState } from 'react';
import { X, Plus } from 'lucide-react';
import { galleryImages } from '../data/galleryImages';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  return (
    <section id="gallery" className="section-padding bg-white border-t border-gray-100">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-4xl mx-auto mb-12 sm:mb-16">
          <div className="inline-block px-3 py-1 bg-white text-primary font-bold text-sm uppercase tracking-wider mb-4 sm:mb-6 border-b-2 border-primary">
            Galerija Radova
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-extrabold text-text mb-4 sm:mb-6">
            Naši <span className="text-primary">Projekti</span>
          </h2>
          <p className="text-gray-800 text-lg sm:text-xl font-medium">
            Pogledajte primere naših projekata, semiranih ormara i izvedenih instalacija.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-6">
          {galleryImages.map((img, index) => (
            <div 
              key={index} 
              className="relative aspect-square overflow-hidden rounded cursor-pointer group bg-gray-100 shadow-md hover:shadow-xl transition-all duration-300 active:scale-95"
              onClick={() => setSelectedImage(img)}
            >
              <img 
                src={img} 
                alt={`Projekat ${index + 1}`} 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              
              {/* Red Hover Overlay - Hidden on mobile to show image clearly */}
              <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/20 transition-colors duration-300 flex items-center justify-center hidden sm:flex">
                <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transform scale-50 group-hover:scale-100 transition-all duration-300 shadow-lg">
                  <Plus className="text-white" size={32} strokeWidth={3} />
                </div>
              </div>
              
              {/* Red Border on Hover */}
              <div className="absolute inset-0 border-4 border-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded pointer-events-none"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-[100] bg-white/95 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-200"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            className="absolute top-4 right-4 sm:top-6 sm:right-6 bg-primary text-white p-2 rounded-full hover:bg-primary-dark transition-colors shadow-lg z-50"
            onClick={() => setSelectedImage(null)}
          >
            <X size={24} className="sm:w-8 sm:h-8" />
          </button>
          
          <div className="relative max-w-5xl max-h-[90vh] w-full flex items-center justify-center">
            <img 
              src={selectedImage} 
              alt="Full size project" 
              className="max-w-full max-h-[85vh] object-contain rounded shadow-2xl border-2 sm:border-4 border-white"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </section>
  );
}
